define([], function () {
    'use strict';

    const ASPECT_NAME = 'vkPostMessage';

    function onPostMessage(e) {
        let msgData;

        try {
            msgData = JSON.parse(e.data);
        } catch (exception) {
            return;
        }

        if (msgData.id && msgData.width) {
            this._siteAspectsSiteAPI.updateAspectComponentData(ASPECT_NAME, msgData.id, msgData);
        }
    }

    /**
     * @constructor
     * @param {core.SiteAspectsSiteAPI} siteAspectsSiteAPI
     */
    function VkPostMessageAspect(siteAspectsSiteAPI) {
        this._siteAspectsSiteAPI = siteAspectsSiteAPI;

        siteAspectsSiteAPI.registerToMessage(onPostMessage.bind(this));
    }

    return {
        ctor: VkPostMessageAspect,
        name: ASPECT_NAME
    };
});
